import React from "react"; // eslint-disable-line no-unused-vars
import "../../ui-elements/Modals";
import { Modal, ModalBody } from "reactstrap";
import "../../css/ui-elements/modals.css";
import { validateField, submitForm } from "../../pages/functions";
import Select from "../../forms/Select";
import InputGroup from "../../forms/InputGroup";
import {
  referenceData,
  selectedCountry,
  listOfCountries,
} from "../../actions/referenceData";
import { setPermissionAction } from "../../actions/config";
import { connect } from "react-redux";
import { switchLanguage } from "../language/actions";
import {
  ABBVIE_EMPLOYEE,
  HCP,
  PATIENT,
  JWT_TOKEN,
  SITE_LANGUAGES,
  GERMANY_PP_SITE_LANGUAGES,
} from "../../constants";
import { formFieldsPerLanguage } from "../language/FormFieldsPerLanguage";
import { initializeReferenceData } from "../../helpers/InitializeStoreData";
import { triggerSSO } from "../InitiateSSO";
import { triggerHCPSSO } from "../InitiateSSO";
import {
  eraseCookieFromAllPaths,
  getCookie,
} from "../../helpers/CookieHandler";
import { api } from "../index.api";
import { RingLoader } from "react-spinners";
import { CircularProgress } from "@material-ui/core";
import { AbbVieLogo } from "../assets/AbbVieLogo";
import {
  frMyspecialtyFieldOptions,
  enMyspecialtyFieldOptions,
  frRegionFieldOptions,
  enRegionFieldOptions,
} from "./WelcomeMI_fieldOptions";

import { config } from "../../json/config.json";
import { Link } from "react-router-dom";

class WelcomeMI extends React.Component {
  constructor(props) {
    super(props);

    const welcomeInit = this.initFromCookies();

    if (document.cookie.indexOf("OauthAuthenticated") === -1) {
      document.cookie = `OauthAuthenticated=false ; max-age=86400`;
    }
    this.language = welcomeInit.language;
    if (this.language === "") {
      this.language =
        require("browser-locale")().split("-").slice(0, 2)[0] !== undefined
          ? require("browser-locale")().split("-").slice(0, 2)[0]
          : "en";
    }
    if (!SITE_LANGUAGES.map((i) => i.value).includes(this.language)) {
      this.language = "en";
    }

    this.switchLanguage = this.props.switchLanguage(
      welcomeInit.language,
      welcomeInit.countryCode,
    );

    this.state = {
      fields: {
        country: {
          name: "country",
          value: welcomeInit.countryValue,
          rules: { title: "Country/Region", required: true },
        },
        isAgree: {
          name: "consent",
          value: welcomeInit.role === HCP,
          rules: { title: "consent", required: false },
        },
        selectedOption: {
          name: "selectedOption",
          value: welcomeInit.role,
          rules: { title: "selectedOption", required: true },
        },
        language: {
          name: "language",
          value: this.language,
          rules: { title: "Language", required: false },
        },
        myspecialty: {
          name: "My Specialty Is",
          value: welcomeInit.myspecialty,
          rules: {
            title: "My Specialty Is",
            required: {
              required: true,
            },
          },
        },
        pickRegion: {
          name: "Pick a Region",
          value: welcomeInit.pickRegion,
          rules: {
            title: "Pick a Region",
            required: {
              required: true,
            },
          },
        },
        licenseNumber: {
          name: "HCP license number",
          value: welcomeInit.licenseNumber,
          rules: {
            title: "HCP license number",
            required: {
              required: true,
            },
          },
        },
      },
      countryCompleteData: [],
      isLoading: true,
      isSubmitting: false,
      countries: [],
      unitedStatesAffiliateValues: [],
      germanyAffiliateValues: [], //germany PP
      gatingMechanismState: false,
      myspecialtyFieldOptions:
        this.language.toLowerCase() === "fr"
          ? frMyspecialtyFieldOptions
          : enMyspecialtyFieldOptions,
      regionFieldOptions:
        this.language.toLowerCase() === "fr"
          ? frRegionFieldOptions
          : enRegionFieldOptions,
      display: this.props.data.content.page.WELCOME_MI,
    };

    formFieldsPerLanguage(this.state.fields, this.props.data.content);
    this.handleSwitchLanguage = this.handleSwitchLanguage.bind(this);
    this.handleSwitchLanguage(this.language);

    this._submit = this._submit.bind(this);
    this.languageSelection();
  }

  languageSelection() {
    if (
      this.state.fields.country.value === 77 &&
      this.state.fields.selectedOption.value === PATIENT
    ) {
      this.languageOptions = GERMANY_PP_SITE_LANGUAGES;
    } else {
      this.languageOptions = SITE_LANGUAGES;
    }
  }

  initFromCookies() {
    const countryValue = getCookie("welcomeCountryValue");
    const welcomeInit = {
      role: getCookie("welcomeRole"),
      language: getCookie("welcomeLanguage"),
      countryValue: countryValue ? parseInt(countryValue, 10) : "",
      countryCode: getCookie("welcomeCountryCode"),
      myspecialty: getCookie("welcomeMyspecialty"),
      pickRegion: getCookie("welcomePickRegion"),
      licenseNumber: getCookie("welcomeLicenseNumber"),
    };

    return welcomeInit;
  }

  _validate(e, field) {
    const fields = validateField(e, field, this.state.fields);

    this.setState({
      fields,
    });

    return false;
  }

  updateData = ({ COUNTRY }) => {
    let usCountryValue = null;
    const usAffiliateValues = [];
    let germanyCountryValue = null; // germany PP
    const germanyAffiliateValues = []; // germany PP
    const countryOptions = [];
    COUNTRY.forEach((country) => {
      if (country.name === "United States") {
        usCountryValue = country.id;
      }
      if (country.affiliate === "USA") {
        usAffiliateValues.push(country.id);
      }
      // Germany PP
      if (country.name === "Germany") {
        germanyCountryValue = country.id;
      }
      // Germany PP
      if (country.affiliate === "Germany") {
        germanyAffiliateValues.push(country.id);
      }
      countryOptions.push({ value: country.id, label: country.name });
    });

    // Ensures that a user will see all employee options when returning to the site after logging in as an employee
    const fields = this.state.fields;
    if (
      usCountryValue &&
      fields.selectedOption.value === ABBVIE_EMPLOYEE &&
      !usAffiliateValues.includes(fields.country.value)
    ) {
      fields.country.value = usCountryValue;
    }

    const selectedCountryValue = COUNTRY.find(
      (country) => country.id === fields.country.value,
    );

    this.setFieldRulesForUserType(
      fields.selectedOption.value,
      fields,
      selectedCountryValue,
    );

    this.setState({
      fields: fields,
      countries: countryOptions,
      countryCompleteData: COUNTRY,
      unitedStatesAffiliateValues: usAffiliateValues,
      germanyAffiliateValues: germanyAffiliateValues,
      isLoading: false,
    });

    this.props.listOfCountries(COUNTRY);
    var countryCodes = config[window.location.hostname].countryCodes;
    const welcomeInit = this.initFromCookies();
    if (
      countryCodes.includes(welcomeInit.countryValue) &&
      getCookie("OauthAuthenticated") == "true"
    ) {
      this.hcpAuth();
    }
  };

  handleSwitchLanguage(language) {
    this.fetchLanguageJson(language, this.state.fields.country.value);
    this.state.fields.myspecialty.errors = [];
    this.state.fields.pickRegion.errors = [];
    this.state.fields.licenseNumber.errors = [];
    if (language === "fr") {
      this.setState({
        myspecialtyFieldOptions: frMyspecialtyFieldOptions,
        regionFieldOptions: frRegionFieldOptions,
      });
    } else {
      this.setState({
        myspecialtyFieldOptions: enMyspecialtyFieldOptions,
        regionFieldOptions: enRegionFieldOptions,
      });
    }
  }

  componentWillReceiveProps({ data }) {
    formFieldsPerLanguage(this.state.fields, data.content);
  }

  componentDidMount() {
    api.fetchCountriesList(this.updateData);
  }

  hcpAuth() {
    const welcomeInit = this.initFromCookies();
    if (welcomeInit.role === HCP) {
      if (getCookie("OauthAuthenticated") == "false") {
        triggerHCPSSO(welcomeInit.language);
        return false;
      } else {
        const actionDispatchers = {
          selectedCountry: this.props.selectedCountry,
          referenceData: this.props.referenceData,
          listOfCountries: this.props.listOfCountries,
          switchLanguage: this.props.switchLanguage,
          setPermissionAction: this.props.setPermissionAction,
        };

        const isConference = false;
        const selectedCountryValue = this.state.countryCompleteData.find(
          (country) => country.id == welcomeInit.countryValue,
        );
        this.setState({ isSubmitting: true });

        initializeReferenceData(
          selectedCountryValue,
          HCP,
          welcomeInit.language,
          actionDispatchers,
          isConference,
          this.props.toggle,
        );
      }
    }
  }

  clearWelcomeCookies = () => {
    eraseCookieFromAllPaths("welcomeCountryValue");
    eraseCookieFromAllPaths("welcomeLanguage");
    eraseCookieFromAllPaths("welcomeRole");
    eraseCookieFromAllPaths("welcomeCountryCode");
    eraseCookieFromAllPaths("welcomeCountryLabel");
    eraseCookieFromAllPaths("selectedEmployeeCountryLabel");
    eraseCookieFromAllPaths("welcomeMyspecialty");
    eraseCookieFromAllPaths("welcomePickRegion");
    eraseCookieFromAllPaths("welcomeLicenseNumber");
  };

  setWelcomeCookies = (
    {
      selectedOption,
      language,
      country,
      myspecialty,
      pickRegion,
      licenseNumber,
    },
    selectedCountryValue,
  ) => {
    document.cookie = `welcomeCountryValue=${country.value}`;
    document.cookie = `welcomeLanguage=${language.value}`;
    document.cookie = `welcomeRole=${selectedOption.value}`;
    document.cookie = `welcomeCountryCode=${selectedCountryValue.abbrevation}`;
    document.cookie = `welcomeCountryLabel=${selectedCountryValue.name}`;
    document.cookie = `selectedEmployeeCountryLabel=${selectedCountryValue.name}`;
    document.cookie = `welcomeMyspecialty=${
      selectedCountryValue.abbrevation.toLowerCase() === "ca"
        ? myspecialty.value
        : ""
    }`;
    document.cookie = `welcomePickRegion=${
      selectedCountryValue.abbrevation.toLowerCase() === "ca"
        ? pickRegion.value
        : ""
    }`;
    document.cookie = `welcomeLicenseNumber=${
      selectedCountryValue.abbrevation.toLowerCase() === "ca"
        ? licenseNumber.value
        : ""
    }`;
  };

  isConsecutive(licenseNumber) {
    let digits = licenseNumber.replace(/\D/g, "");
    let strNum = String(digits);
    for (let i = 0; i < strNum.length - 1; i++) {
      if (Math.abs(strNum[i] - strNum[i + 1]) !== 1) {
        return false;
      }
    }
    return true;
  }
  isFullLengthRecurring(licenseNumber) {
    let digits = licenseNumber.replace(/\D/g, "");
    let numStr = digits.toString();
    let firstDigit = numStr[0];
    for (let i = 1; i < numStr.length; i++) {
      if (numStr[i] !== firstDigit) {
        return false;
      }
    }
    return true;
  }

  _submit(e) {
    e.preventDefault();
    this.clearWelcomeCookies();
    const fields = submitForm(e, this.state.fields);
    this.setState({ fields });
    const selectedUserType = fields.selectedOption.value;
    const selectedCountryValue = this.state.countryCompleteData.find(
      (country) => country.id === fields.country.value,
    );

    this.setFieldRulesForUserType(
      fields.selectedOption.value,
      fields,
      selectedCountryValue,
    );
    this.setWelcomeCookies(fields, selectedCountryValue);

    for (const key in fields) {
      if (fields[key].errors.length > 0) {
        return false;
      }
    }

    const selectedLanguage = fields.language.value;
    if (selectedUserType === ABBVIE_EMPLOYEE) {
      triggerSSO(selectedLanguage);
      return false;
    }
    var countryCodes = config[window.location.hostname].countryCodes;
    const welcomeInit = this.initFromCookies();
    if (
      countryCodes.includes(welcomeInit.countryValue) &&
      selectedUserType === HCP
    ) {
      this.hcpAuth();
      return false;
    }

    eraseCookieFromAllPaths(JWT_TOKEN);
    eraseCookieFromAllPaths("OauthAuthenticated");

    const actionDispatchers = {
      selectedCountry: this.props.selectedCountry,
      referenceData: this.props.referenceData,
      listOfCountries: this.props.listOfCountries,
      switchLanguage: this.props.switchLanguage,
      setPermissionAction: this.props.setPermissionAction,
    };
    const isConference = false;
    this.setState({ isSubmitting: true });

    const licenseNumber = fields.licenseNumber.value;
    const pickRegion = fields.pickRegion.value;
    const myspecialty = fields.myspecialty.value;

    if (selectedUserType === HCP && selectedCountryValue.name === "Canada") {
      if (
        this.isConsecutive(licenseNumber) ||
        this.isFullLengthRecurring(licenseNumber) ||
        licenseNumber.replace(/\D/g, "").match(/^(\d{2,4})\1+$/)
      ) {
        this.setState({ isSubmitting: false });
        this.setState({ gatingMechanismState: true });
      } else if (
        (licenseNumber.match(/^(?:[a-zA-Z]\d{5}|0\d{4})$/) &&
          pickRegion === "NEWFOUNDLAND & LABRADOR" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^[0-9]{6}$/) &&
          pickRegion === "NOVA SCOTIA" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(?:\d{3,4}|[a-zA-Z]\d{4}|[a-zA-Z]{2}\d{4})$/) &&
          pickRegion === "PRINCE EDWARD ISLAND" &&
          myspecialty === "physician") ||
        ((licenseNumber.match(
          /^\d{2}-(?!0123|1234|2345|3456|4567|5678|6789|9876|8765|7654|6543|5432|4321|3210)\d{4,5}$/,
        ) ||
          licenseNumber.match(/^[0-9]{4}$/) ||
          licenseNumber.match(/^[0-9]{5}$/)) &&
          pickRegion === "NEW BRUNSWICK" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^[0-9]{5}$/) &&
          pickRegion === "QUEBEC" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^[0-9]{5}(?:[0-9]{1})?$/) &&
          pickRegion === "ONTARIO" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(?=.*-)([0-9]-?){4}[0-9]$/) &&
          pickRegion === "MANITOBA" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^[0-9]{4}(?:[0-9]{2})?$/) &&
          pickRegion === "SASKATCHEWAN" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(0)[0-9]{5}$/) &&
          pickRegion === "ALBERTA" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(?!.*0.*0.*0)[0-9]\d{2}(?:\d{2})?$/) &&
          pickRegion === "BRITISH COLUMBIA" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(2500|2502)-\d{5}\d{4}$/) &&
          pickRegion === "NORTHWEST TERRITORIES" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(?=.*\d)[0-9]{6}$/) &&
          pickRegion === "NUNAVUT" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(?=.*-)([0-9]-?){7}[0-9]$/) &&
          pickRegion === "YUKON" &&
          myspecialty === "physician") ||
        (licenseNumber.match(/^(\d{2})-(\d{3,4})$/) &&
          pickRegion === "NEWFOUNDLAND & LABRADOR" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{2,4}$/) &&
          pickRegion === "NOVA SCOTIA" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{4,5}$/) &&
          pickRegion === "PRINCE EDWARD ISLAND" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{4}$/) &&
          pickRegion === "NEW BRUNSWICK" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{4,6}$/) &&
          pickRegion === "QUEBEC" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{3,6}$/) &&
          pickRegion === "ONTARIO" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{5}$/) &&
          pickRegion === "MANITOBA" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[A-Za-z]\d{4}$/) &&
          pickRegion === "SASKATCHEWAN" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{4,5}$/) &&
          pickRegion === "ALBERTA" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^(0)[0-9]{4}$/) &&
          pickRegion === "BRITISH COLUMBIA" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^\d{4}-\d{5}$/) &&
          pickRegion === "NORTHWEST TERRITORIES" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^1\d{3}-\d{5}$/) &&
          pickRegion === "NUNAVUT" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^(?=.*-)([0-9]-?){7}[0-9]$/) &&
          pickRegion === "YUKON" &&
          myspecialty === "pharmacist") ||
        (licenseNumber.match(/^[0-9]{4}$/) &&
          pickRegion === "NEWFOUNDLAND & LABRADOR" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{4,5}$/) &&
          pickRegion === "NOVA SCOTIA" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{6}$/) &&
          pickRegion === "PRINCE EDWARD ISLAND" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{6}$/) &&
          pickRegion === "NEW BRUNSWICK" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{6,7}$/) &&
          pickRegion === "QUEBEC" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^([A-Za-z]{2}\d{5,6}$|^\d{7})$/) &&
          pickRegion === "ONTARIO" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{6}$/) &&
          pickRegion === "MANITOBA" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{7}$/) &&
          pickRegion === "SASKATCHEWAN" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{4,5}$/) &&
          pickRegion === "ALBERTA" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^(0)[0-9]{6}$/) &&
          pickRegion === "BRITISH COLUMBIA" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{4}$/) &&
          pickRegion === "NORTHWEST TERRITORIES" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{4}$/) &&
          pickRegion === "NUNAVUT" &&
          myspecialty === "nurse") ||
        (licenseNumber.match(/^[0-9]{4}$/) &&
          pickRegion === "YUKON" &&
          myspecialty === "nurse")
      ) {
        initializeReferenceData(
          selectedCountryValue,
          selectedUserType,
          selectedLanguage,
          actionDispatchers,
          isConference,
          this.props.toggle,
        );
      } else {
        this.setState({ isSubmitting: false });
        this.setState({ gatingMechanismState: true });
      }
    } else {
      initializeReferenceData(
        selectedCountryValue,
        selectedUserType,
        selectedLanguage,
        actionDispatchers,
        isConference,
        this.props.toggle,
      );
    }
  }

  fetchLanguageJson = (language, countryValue) => {
    if (this.state.countryCompleteData.length > 0) {
      const selectedCountry = this.state.countryCompleteData.find(
        (country) => country.id === countryValue,
      );

      const selectedCountryCode = selectedCountry
        ? selectedCountry.abbrevation.toLocaleLowerCase()
        : "us";
      this.props.switchLanguage(language, selectedCountryCode);
    }
  };

  handleCountryChange = (event) => {
    this.fetchLanguageJson(
      this.state.fields.language.value,
      event.target.value,
    );
    const selectedRole = "";
    this.resetUserTypeValues(selectedRole, this.state.fields);
    this._validate(event, this.state.fields.country);
    this.languageSelection();
  };

  handleUserTypeChange = (event) => {
    const copyfields = this.state.fields;
    const selectedCountryValue = this.state.countryCompleteData.find(
      (country) => country.id === this.state.fields.country.value,
    );
    this.setFieldRulesForUserType(
      event.target.value,
      copyfields,
      selectedCountryValue,
    );
    this.resetUserTypeValues(event.target.value, copyfields);
    this.setState({ fields: copyfields });
    this.languageSelection();
  };

  handleCertChange = (event) => {
    const copyfields = this.state.fields;
    copyfields.isAgree.value = event.target.checked;
    copyfields.isAgree.errors = [];
    this.setState({ fields: copyfields });
  };

  resetUserTypeValues = (userType, fields) => {
    fields.selectedOption.value = userType;
    fields.selectedOption.errors = [];
    fields.isAgree.value = false;
    fields.isAgree.errors = [];
    fields.myspecialty.errors = [];
    fields.pickRegion.errors = [];
    fields.licenseNumber.errors = [];
    this.state.gatingMechanismState = false;
  };

  setFieldRulesForUserType = (userType, fields, selectedCountryValue) => {
    if (userType === ABBVIE_EMPLOYEE) {
      fields.isAgree.rules.required = false;
      fields.isAgree.rules.ignoreNull = true;
      fields.country.rules.required = false;
      fields.country.rules.ignoreNull = true;
      fields.myspecialty.rules.required.required = false;
      fields.myspecialty.rules.ignoreNull = true;
      fields.pickRegion.rules.required.required = false;
      fields.pickRegion.rules.ignoreNull = true;
      fields.licenseNumber.rules.required.required = false;
      fields.licenseNumber.rules.ignoreNull = true;
    } else if (userType === HCP) {
      if (selectedCountryValue.name === "Canada") {
        fields.isAgree.rules.required = true;
        fields.isAgree.rules.ignoreNull = false;
        fields.country.rules.required = true;
        fields.country.rules.ignoreNull = false;
        fields.myspecialty.rules.required.required = true;
        fields.myspecialty.rules.ignoreNull = false;
        fields.pickRegion.rules.required.required = true;
        fields.pickRegion.rules.ignoreNull = false;
        fields.licenseNumber.rules.required.required = true;
        fields.licenseNumber.rules.ignoreNull = false;
      } else {
        fields.isAgree.rules.required = true;
        fields.isAgree.rules.ignoreNull = false;
        fields.country.rules.required = true;
        fields.country.rules.ignoreNull = false;
        fields.myspecialty.rules.required.required = false;
        fields.myspecialty.rules.ignoreNull = true;
        fields.pickRegion.rules.required.required = false;
        fields.pickRegion.rules.ignoreNull = true;
        fields.licenseNumber.rules.required.required = false;
        fields.licenseNumber.rules.ignoreNull = true;
      }
    } else {
      fields.isAgree.rules.required = false;
      fields.isAgree.rules.ignoreNull = true;
      fields.country.rules.required = true;
      fields.country.rules.ignoreNull = false;
      fields.myspecialty.rules.required.required = false;
      fields.myspecialty.rules.ignoreNull = true;
      fields.pickRegion.rules.required.required = false;
      fields.pickRegion.rules.ignoreNull = true;
      fields.licenseNumber.rules.required.required = false;
      fields.licenseNumber.rules.ignoreNull = true;
    }
  };

  render() {
    const languageContent = this.props.data.content;
    const roleSelectionError =
      this.state.fields.selectedOption.errors &&
      this.state.fields.selectedOption.errors.length > 0;
    const certSelectionError =
      this.state.fields.isAgree.errors &&
      this.state.fields.isAgree.errors.length > 0;

    return (
      <div>
        <Modal
          className="welcome-modal"
          isOpen={this.props.isOpen}
          backdrop
          keyboard={false}
          wrapClassName="backdrop-modal"
          size="lg"
          fade={false}
          onOpened={addBodyStyles}
          onClosed={() =>
            toggleSecondModal(
              this.state.fields.selectedOption.value === PATIENT,
              this.props.togglePatientDisclosureModal,
            )
          }
        >
          <div className="modal-title-color modal-title-logo">
            <div className="logo-img">
              <AbbVieLogo width="120px" height="21.72px" />
            </div>
            <div className="logo-separator" />
            <div className="logo-text">
              <h5>
                <strong>{languageContent.page.WELCOME_MI.header}</strong>
              </h5>
              <h6>{languageContent.page.WELCOME_MI.subHeader}</h6>
            </div>
          </div>
          <div className="modal-disclosure">
            <div>{languageContent.page.WELCOME_MI.siteDescription}</div>
          </div>
          <ModalBody>
            <div className="row mb-3">
              <div className="col">
                <Select
                  className="custom-select form-control"
                  searchable
                  clearable={false}
                  options={this.languageOptions}
                  onChange={this.handleSwitchLanguage}
                  field={this.state.fields.language}
                  validate={(e, field) =>
                    this._validate(e, this.state.fields.language)
                  }
                  disabled={this.state.isSubmitting}
                />
              </div>
            </div>

            {this.state.fields.selectedOption.value !== ABBVIE_EMPLOYEE ? (
              <div className="row mb-3">
                <div className="col">
                  <Select
                    className="custom-select form-control"
                    searchable
                    clearable
                    options={this.state.countries}
                    field={this.state.fields.country}
                    validate={this.handleCountryChange}
                    disabled={this.state.isSubmitting}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            <div>
              <p>
                *If country is not listed, Please{" "}
                <a href="/country-not-available">CLICK HERE</a>
              </p>
            </div>

            <div>
              <RingLoader color="#071d49" loading={this.state.isLoading} />
            </div>

            {this.state.fields.country.value && !this.state.isLoading && (
              <React.Fragment>
                <div className="row" style={{ marginBottom: "2rem" }}>
                  <div className="col-xs-12 col-sm-3 i-am">
                    <h5>
                      <strong>{languageContent.page.WELCOME_MI.iAm}</strong>
                    </h5>
                  </div>
                  <div className="col-xs-12 col-sm-9">
                    <div
                      className={
                        roleSelectionError
                          ? "has-danger custom-controls-stacked"
                          : "custom-controls-stacked"
                      }
                    >
                      <label className="custom-control custom-radio">
                        <input
                          name="radio"
                          className="custom-control-input"
                          value={HCP}
                          type="radio"
                          checked={
                            this.state.fields.selectedOption.value === HCP
                          }
                          onChange={this.handleUserTypeChange}
                          disabled={this.state.isSubmitting}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          {languageContent.page.WELCOME_MI.hcp}
                        </span>
                      </label>
                      {this.state.fields.country.value === 24 &&
                        this.state.fields.selectedOption.value === HCP && (
                          <div className="gating_Mechanism_wrapper">
                            <Select
                              className="custom-select form-control"
                              searchable
                              clearable={false}
                              options={this.state.myspecialtyFieldOptions}
                              field={this.state.fields.myspecialty}
                              validate={(e, field) =>
                                this._validate(e, this.state.fields.myspecialty)
                              }
                              disabled={this.state.isSubmitting}
                            />
                            <Select
                              className="custom-select form-control"
                              searchable
                              clearable={false}
                              options={this.state.regionFieldOptions}
                              field={this.state.fields.pickRegion}
                              validate={(e, field) =>
                                this._validate(e, this.state.fields.pickRegion)
                              }
                              disabled={this.state.isSubmitting}
                            />
                            <InputGroup
                              field={this.state.fields.licenseNumber}
                              validate={(e, field) =>
                                this._validate(
                                  e,
                                  this.state.fields.licenseNumber,
                                )
                              }
                            />
                          </div>
                        )}
                      <label className="custom-control custom-radio">
                        <input
                          name="radio"
                          className="custom-control-input"
                          value={ABBVIE_EMPLOYEE}
                          type="radio"
                          checked={
                            this.state.fields.selectedOption.value ===
                            ABBVIE_EMPLOYEE
                          }
                          onChange={this.handleUserTypeChange}
                          disabled={this.state.isSubmitting}
                        />
                        <span className="custom-control-indicator" />
                        <span className="custom-control-description">
                          {languageContent.page.WELCOME_MI.abbvieEmployee}
                        </span>
                      </label>
                      {this.state.unitedStatesAffiliateValues.includes(
                        this.state.fields.country.value,
                      ) && (
                        <label className="custom-control custom-radio">
                          <input
                            name="radio"
                            className="custom-control-input"
                            value={PATIENT}
                            type="radio"
                            checked={
                              this.state.fields.selectedOption.value === PATIENT
                            }
                            onChange={this.handleUserTypeChange}
                            disabled={this.state.isSubmitting}
                          />
                          <span className="custom-control-indicator" />
                          <span className="custom-control-description">
                            {languageContent.page.WELCOME_MI.patientOrCaregiver}
                          </span>
                        </label>
                      )}
                      {
                        // added && this.state.germanyAffiliateValues.includes(this.state.fields.country.value) for germany PP
                        this.state.germanyAffiliateValues.includes(
                          this.state.fields.country.value,
                        ) && (
                          <label className="custom-control custom-radio">
                            <input
                              name="radio"
                              className="custom-control-input"
                              value={PATIENT}
                              type="radio"
                              checked={
                                this.state.fields.selectedOption.value ===
                                PATIENT
                              }
                              onChange={this.handleUserTypeChange}
                              disabled={this.state.isSubmitting}
                            />
                            <span className="custom-control-indicator" />
                            <span className="custom-control-description">
                              {
                                languageContent.page.WELCOME_MI
                                  .patientOrCaregiver
                              }
                            </span>
                          </label>
                        )
                      }
                      <label className="custom-control custom-radio">
                        <span className="" />
                        <span className="custom-control-description">
                          <a
                            href={
                              languageContent.page.HOME.medicalInquiryMenu
                                .generalRequestsLink
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {languageContent.page.WELCOME_MI.other}
                          </a>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className={certSelectionError ? "has-danger" : null}>
                    {this.state.fields.selectedOption.value === HCP ? (
                      <label className="custom-control custom-checkbox mr-0">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          checked={this.state.fields.isAgree.value}
                          onChange={this.handleCertChange}
                          disabled={this.state.isSubmitting}
                        />
                        <span
                          id="termsCheckBox"
                          className="custom-control-indicator"
                        />
                        <span className="custom-control-description">
                          {languageContent.page.WELCOME_MI.declaration}
                        </span>
                      </label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {this.state.gatingMechanismState && (
                  <div className="row gatingMechanism_Error">
                    {languageContent.page.WELCOME_MI.requiredLicenseNumber}
                  </div>
                )}
                <div className="row">
                  <div className="col form-group text-center">
                    <button
                      type="submit"
                      onClick={this._submit}
                      className="btn btn-lg btn-info btn-rounded"
                      disabled={this.state.isSubmitting}
                    >
                      {this.state.isSubmitting ? (
                        <div className="loading-text">
                          {languageContent.page.WELCOME_MI.enter}
                          <CircularProgress
                            size={26}
                            className="loading-progress"
                          />
                        </div>
                      ) : (
                        <React.Fragment>
                          {languageContent.page.WELCOME_MI.enter}
                        </React.Fragment>
                      )}
                    </button>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const addBodyStyles = () => {
  document.body.classList.add("welcome-modal-body");
};

const toggleSecondModal = (shouldToggle, toggleDisclosureModal) => {
  document.body.classList.remove("welcome-modal-body");
  if (shouldToggle) {
    toggleDisclosureModal();
  }
};

function mapStateToProps(state) {
  return {
    referenceData: state,
    data: state.pageContent,
  };
}

export default connect(mapStateToProps, {
  selectedCountry,
  referenceData,
  listOfCountries,
  switchLanguage,
  setPermissionAction,
})(WelcomeMI);



// WEBPACK FOOTER //
// ./src/mi-app/modals/WelcomeMI.js